module.exports = __webpack_public_path__ + "static/img/class_20.2559f0dd.jpg";